/**
 * Ayuda — Ventas → Facturas
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_SAL_INVOICES_ITEM = {
  id: 'invoices',
  screenId: 'adm-sal-invoices',
  label: 'Facturas',
  description: 'Emití y consultá facturas de venta a clientes.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá registrás las facturas que emitís a tus clientes. Podés cargarlas a mano, crearlas desde un remito pendiente, registrar el cobro en el mismo momento o dejarlas en cuenta corriente.',
      },
      {
        title: 'Paso 1 — Buscar facturas',
        fields: [
          {
            label: 'Fecha Desde / Fecha Hasta',
            description: 'Filtrá por el período de emisión.',
          },
          {
            label: 'Cliente',
            description: 'Elegí un cliente para ver solo sus facturas.',
          },
          {
            label: 'Botón Buscar',
            description: 'Actualiza la lista.',
          },
          {
            label: 'Filtro avanzado',
            description:
              'Tocá «Filtro Avanzado >» para buscar por número y, si hace falta, marcar «Mostrar Facturas Eliminadas» para incluir las que fueron dadas de baja.',
          },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Fecha, Cliente, Tipo Fac., Número, Total y Moneda.',
          'Ícono de lápiz — la edición no está disponible por ahora; el sistema lo informa.',
          'Ícono de cruz (×) — eliminar la factura.',
        ],
        paragraphs: [
          'Tocá una fila para ver el detalle completo.',
        ],
      },
      {
        title: 'Paso 3 — Cargar una factura nueva',
        intro: 'El botón + abre «Factura a Clientes». Los pasos principales del formulario son:',
      },
      {
        title: 'Encabezado de la factura',
        fields: [
          {
            label: 'Fecha de emisión',
            description: 'Día en que se emite el comprobante.',
          },
          {
            label: 'Tipo de factura',
            description: 'Factura A, B, C, nota de crédito, nota de débito, etc., según lo configurado.',
          },
          {
            label: 'Punto de venta',
            description: 'Numeración desde la cual emitís.',
          },
          {
            label: 'Número',
            description: 'En comprobantes no electrónicos lo completás a mano. Si es factura electrónica, el sistema la gestiona con AFIP y muestra «FACTURA ELECTRONICA».',
          },
          {
            label: 'Concepto (factura electrónica)',
            description: 'Productos, Servicios, o ambos. Si elegís Servicios, aparecen fechas de servicio y vencimiento de pago.',
          },
        ],
      },
      {
        title: 'Cliente',
        intro:
          'Buscá el cliente o cargá sus datos si es consumidor final u ocasional. Al elegir un cliente, el sistema puede traer su lista de precios y calcular percepciones impositivas si corresponde.',
      },
      {
        title: 'Comprobantes relacionados',
        bullets: [
          '«Crear desde Remito» — trae las líneas de remitos del cliente que aún no se facturaron. Si el remito tiene precio, se convierte de la moneda del remito a la de la factura. Si no tiene, se usa la lista de precios de la factura.',
          'En notas de crédito o débito — indicá la factura original (tipo, punto de venta y número) y tocá Buscar.',
        ],
      },
      {
        title: 'Líneas de la factura',
        fields: [
          {
            label: 'Moneda y lista de precios',
            description: 'Moneda del comprobante y lista de precios a usar. Si la moneda no es pesos, se muestra la cotización.',
          },
          {
            label: 'Producto, Cantidad, Precio unitario',
            description: 'Cada línea: artículo, cantidad y precio. Los importes se calculan solos.',
          },
          {
            label: 'IVA por línea',
            description: 'Si corresponde, elegís la alícuota (21 %, 10,5 %, etc.).',
          },
          {
            label: 'Promociones y regalos',
            description: 'Descuentos automáticos o productos de regalo según promociones activas.',
          },
          {
            label: 'Dar salida a los artículos',
            description: 'Si hay productos con stock y no vienen de un remito, podés marcar que salgan del depósito al confirmar la factura.',
          },
          {
            label: 'Agregar línea',
            description: 'Sumá más productos al comprobante.',
          },
        ],
      },
      {
        title: 'Percepciones, totales y pagos',
        fields: [
          {
            label: 'Percepciones impositivas',
            description: 'Si el cliente las tiene configuradas, el sistema las calcula (IIBB u otras).',
          },
          {
            label: 'Totales',
            description: 'Resumen de netos, IVA y total antes de guardar.',
          },
          {
            label: 'Observaciones',
            description: 'Notas generales (opcional).',
          },
          {
            label: 'Método de pago',
            description:
              'Podés dejarlo vacío, elegir Cuenta Corriente (cobra después) o Cobro (registrás el cobro en el acto con medios de pago).',
          },
          {
            label: 'Limpiar formulario / Confirmar',
            description: 'Limpiar borra todo para cargar otra factura. Confirmar guarda el comprobante.',
          },
        ],
      },
      {
        title: 'Ver el detalle de una factura',
        bullets: [
          'Datos del comprobante, cliente, artículos y totales.',
          'Ver Cobros — recibos asociados a esa factura.',
          'Ver Comprobantes Relacionados — remitos u otros vínculos.',
          'Imprimir — genera el PDF.',
          'Eliminar factura — con confirmación; si tiene cobros, el sistema puede pedir opciones adicionales.',
        ],
      },
      {
        title: 'Eliminar una factura',
        intro:
          'Tocá la cruz en la lista o «Eliminar factura» en el detalle. Confirmá con «SI» o cancelá con «NO». Si la factura tiene cobros imputados, el sistema puede mostrar advertencias y opciones extra antes de borrar.',
      },
    ],
  },
}
